import { render } from "./UserPage.vue?vue&type=template&id=a90aec9e&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=a90aec9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a90aec9e"

export default script